if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();
      this.setProductTitle(this.dataset.productTitle);
      this.display();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    display() {
      // reveal
      setTimeout(() => this.classList.remove('added-notification--hidden'), 10);

      // dismiss after a short period of time
      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), 6000);

      // close button
      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));

      // P1-6: make the WHOLE notification tappable (open the cart), not just
      // the small "cart" link — the narrow target caused mis-taps on mobile.
      this.addEventListener('click', (evt) => {
        if (evt.target.closest('.added-notification__close')) return;
        evt.preventDefault();
        if (theme.settings.cartType === 'drawer' && document.querySelector('.js-cart-drawer')) {
          document.querySelector('.js-cart-drawer').open();
          this.dismiss();
        } else if (theme.routes && theme.routes.cart) {
          window.location.href = theme.routes.cart;
        }
      });
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 2000);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
